import React, { useState } from "react";
import { TbBuildingWarehouse } from "react-icons/tb";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { useSelector } from "react-redux";

const AssetMaintenance = ({ searchTerm = "" }) => {
  const [percentageFilter, setPercentageFilter] = useState("All");
  const [divisionFilter, setDivisionFilter] = useState("All");
  const [ageFilter, setAgeFilter] = useState("All");
  const [maintCountFilter, setMaintCountFilter] = useState("All");

  const themeMode = useSelector((state) => state.theme.mode);
  const textColorClass = themeMode ? "text-slate-200" : "text-slate-900";
  const bgColorClass = themeMode ? "bg_light_main" : "bg-white";
  const borderThem = themeMode ? "border_them_2" : "border-primary";
  const tableHedBg = themeMode ? "bg-slate-800" : "bg-slate-50";
  const scrollBg = themeMode ? "sidebar_scroll_dark" : "sidebar_scroll";

  const [inventoryData] = useState([
    {
      id: "A-101",
      name: "Tubewell Pump J-1",
      maintenanceCount: 5,
      totalMaintenanceCost: 12000,
      estimatedmaintenance:10,
      assetCost: 50000,
      assetAge: 2,
      division: "Jammu",
      subDivision: "Gandhi Nagar",
    },
    {
      id: "A-102",
      name: "Main Pumping Station P-4",
      maintenanceCount: 12,
      totalMaintenanceCost: 45000,
      assetCost: 250000,
      estimatedmaintenance:13,
      assetAge: 5,
      division: "Jammu",
      subDivision: "Trikuta Nagar",
    },
    {
      id: "A-103",
      name: "Chlorination Plant Unit",
      maintenanceCount: 3,
      totalMaintenanceCost: 8500,
      assetCost: 35000,
      estimatedmaintenance:20,
      assetAge: 1,
      division: "Samba",
      subDivision: "Bari Brahmana",
    },
    {
      id: "A-104",
      name: "Electric Transformer 11KV",
      maintenanceCount: 8,
      totalMaintenanceCost: 22000,
      assetCost: 120000,
      estimatedmaintenance:10,
      assetAge: 4,
      division: "Kathua",
      subDivision: "Industrial Area",
    },
    {
      id: "A-105",
      name: "Generator Set 50KVA",
      maintenanceCount: 15,
      totalMaintenanceCost: 65000,
      assetCost: 180000,
      estimatedmaintenance:7,
      assetAge: 6,
      division: "Jammu",
      subDivision: "Janipur",
    },
    {
      id: "A-106",
      name: "Water Filtration Bed-A",
      maintenanceCount: 2,
      totalMaintenanceCost: 5400,
      assetCost: 80000,
      estimatedmaintenance:16,
      assetAge: 3,
      division: "Samba",
      subDivision: "Vijaypur",
    },
  ]);

  return (
    <div className={`w-full ${bgColorClass} h-full flex flex-col`}>
      <div
        className={`py-4 md:px-12 px-6 border-b ${borderThem} flex justify-between items-center h-[57px] shrink-0`}
      >
        <div
          className={`flex ps-3 md:ps-0 text-sm md:text-base ${textColorClass} items-center gap-x-2`}
        >
          <TbBuildingWarehouse className="cursor-pointer font-semibold text-xl" />
          <p className="font-semibold">Asset Maintenance</p>
        </div>
      </div>

      <div className={`flex-1 overflow-y-auto pb-10 ${scrollBg}`}>
        <div className="px-3 md:px-8 mt-4">
          <div className="flex flex-wrap items-center gap-3 mb-3">
            <Select
              onValueChange={(v) => setDivisionFilter(v)}
              defaultValue="All"
            >
              <SelectTrigger
                className={`w-[160px] h-8 text-xs bg-transparent ${textColorClass} ${borderThem}`}
              >
                <SelectValue placeholder="Division" />
              </SelectTrigger>
              <SelectContent
                className={themeMode ? "bg-slate-900 text-white" : "bg-white"}
              >
                <SelectItem value="All">All Divisions</SelectItem>
                <SelectItem value="Jammu">Jammu</SelectItem>
                <SelectItem value="Samba">Samba</SelectItem>
                <SelectItem value="Kathua">Kathua</SelectItem>
              </SelectContent>
            </Select>

            <Select onValueChange={(v) => setAgeFilter(v)} defaultValue="All">
              <SelectTrigger
                className={`w-[140px] h-8 text-xs bg-transparent ${textColorClass} ${borderThem}`}
              >
                <SelectValue placeholder="Asset Age" />
              </SelectTrigger>
              <SelectContent
                className={themeMode ? "bg-slate-900 text-white" : "bg-white"}
              >
                <SelectItem value="All">All Ages</SelectItem>
                <SelectItem value="1-2">1-2 Years</SelectItem>
                <SelectItem value="3-5">3-5 Years</SelectItem>
                <SelectItem value="5+">5+ Years</SelectItem>
              </SelectContent>
            </Select>

            <Select
              onValueChange={(v) => setMaintCountFilter(v)}
              defaultValue="All"
            >
              <SelectTrigger
                className={`w-[150px] h-8 text-xs bg-transparent ${textColorClass} ${borderThem}`}
              >
                <SelectValue placeholder="Maint. Count" />
              </SelectTrigger>
              <SelectContent
                className={themeMode ? "bg-slate-900 text-white" : "bg-white"}
              >
                <SelectItem value="All">All Counts</SelectItem>
                <SelectItem value="0-5">0-5 Times</SelectItem>
                <SelectItem value="6-10">6-10 Times</SelectItem>
                <SelectItem value="11+">11+ Times</SelectItem>
              </SelectContent>
            </Select>

            <Select
              onValueChange={(v) => setPercentageFilter(v)}
              defaultValue="All"
            >
              <SelectTrigger
                className={`w-[160px] h-8 text-xs bg-transparent ${textColorClass} ${borderThem}`}
              >
                <SelectValue placeholder="Maint. Cost %" />
              </SelectTrigger>
              <SelectContent
                className={themeMode ? "bg-slate-900 text-white" : "bg-white"}
              >
                <SelectItem value="All">All Cost %</SelectItem>
                <SelectItem value="low">Low (&lt;10%)</SelectItem>
                <SelectItem value="medium">Medium (10-25%)</SelectItem>
                <SelectItem value="high">High (&gt;25%)</SelectItem>
              </SelectContent>
            </Select>
          </div>

          <div
            className={`overflow-x-auto ${scrollBg} rounded-lg border ${borderThem}`}
          >
            <table className="w-full text-left table-auto border-collapse">
              <thead>
                <tr
                  className={`${tableHedBg} text-[10px] ${borderThem} uppercase tracking-wider ${textColorClass} font-bold border-b`}
                >
                  <th className="px-4 py-3 min-w-48">Asset Name</th>
                  <th className="px-4 py-3 min-w-38">Esti. Maint. Cost %</th>
                  <th className="px-4 py-3 min-w-32 text-center">
                    Maint. Count
                  </th>
                  <th className="px-4 py-3 min-w-36 text-right">
                    Total Maint. Cost
                  </th>
                  <th className="px-4 py-3 min-w-32 text-right">Asset Cost</th>
                  <th className="px-4 py-3 min-w-24 text-center">Maint. %</th>
                  <th className="px-4 py-3 min-w-24 text-center">Age (Yrs)</th>
                  <th className="px-4 py-3 min-w-32">Division</th>
                  <th className="px-4 py-3 min-w-40">Sub Division</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100">
                {inventoryData
                  .filter((i) =>
                    i.name.toLowerCase().includes(searchTerm.toLowerCase())
                  )
                  .filter(
                    (i) =>
                      divisionFilter === "All" || i.division === divisionFilter
                  )
                  .filter((i) => {
                    if (ageFilter === "All") return true;
                    if (ageFilter === "1-2") return i.assetAge <= 2;
                    if (ageFilter === "3-5")
                      return i.assetAge >= 3 && i.assetAge <= 5;
                    if (ageFilter === "5+") return i.assetAge > 5;
                    return true;
                  })
                  .filter((i) => {
                    if (maintCountFilter === "All") return true;
                    if (maintCountFilter === "0-5")
                      return i.maintenanceCount <= 5;
                    if (maintCountFilter === "6-10")
                      return (
                        i.maintenanceCount >= 6 && i.maintenanceCount <= 10
                      );
                    if (maintCountFilter === "11+")
                      return i.maintenanceCount > 10;
                    return true;
                  })
                  .filter((item) => {
                    const percentage =
                      (item.totalMaintenanceCost / item.assetCost) * 100;
                    if (percentageFilter === "low") return percentage < 10;
                    if (percentageFilter === "medium")
                      return percentage >= 10 && percentage <= 25;
                    if (percentageFilter === "high") return percentage > 25;
                    return true;
                  })
                  .sort(
                    (a, b) => b.totalMaintenanceCost - a.totalMaintenanceCost
                  )
                  .map((row) => {
                    const mPercent =
                      (row.totalMaintenanceCost / row.assetCost) * 100;
                    return (
                      <tr
                        key={row.id}
                        className={`hover:bg-slate-50/50 ${borderThem} transition-colors text-xs ${
                          mPercent > 25
                            ? themeMode
                              ? "bg-rose-900/20"
                              : "bg-rose-50/40"
                            : ""
                        }`}
                      >
                        <td
                          className={`px-4 py-3 ${textColorClass} font-medium underline decoration-slate-400 decoration-dotted`}
                        >
                          {row.name}
                        </td>
                        <td
                          className={`px-4 py-3 text-center font-semibold ${textColorClass}`}
                        >
                          {row.estimatedmaintenance}%
                        </td>
                        <td
                          className={`px-4 py-3 text-center font-semibold ${textColorClass}`}
                        >
                          {row.maintenanceCount}
                        </td>
                        <td className="px-4 py-3 text-right font-mono font-bold text-indigo-600">
                          ₹{row.totalMaintenanceCost.toLocaleString()}
                        </td>
                        <td
                          className={`px-4 py-3 text-right font-mono ${textColorClass} opacity-80`}
                        >
                          ₹{row.assetCost.toLocaleString()}
                        </td>
                        <td className="px-4 py-3 text-center">
                          <span
                            className={`font-bold ${
                              mPercent > 10
                                ? "text-rose-500"
                                :  "text-emerald-500"
                            }`}
                          >
                            {mPercent.toFixed(1)}%
                          </span>
                        </td>
                        <td
                          className={`px-4 py-3 text-center ${textColorClass}`}
                        >
                          {row.assetAge}
                        </td>
                        <td
                          className={`px-4 py-3 ${textColorClass} font-semibold opacity-70`}
                        >
                          {row.division}
                        </td>
                        <td
                          className={`px-4 py-3 ${textColorClass} opacity-60 italic`}
                        >
                          {row.subDivision}
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AssetMaintenance;
